import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { SCDialogModel } from '../../models/save-changes-dialog.model';

@Component({
  selector: 'save-changes-dialog',
  imports: [CommonModule, MatDialogModule],
  templateUrl: './save-changes-dialog.component.html',
  styleUrl: './save-changes-dialog.component.scss',
})
export class SaveChangesDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<SaveChangesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: SCDialogModel,
  ) {
    dialogRef.disableClose = true;
  }

  onCancel() {
    this.dialogRef.close();
  }
}
